module.exports = __webpack_public_path__ + "static/img/img138.9f96294.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img138.png
// module id = lzru
// module chunks = 5